//--- hide the sidebar image and slider in vendor or type in url

window.addEventListener("DOMContentLoaded", function () {
  hideElementsInParent("product__info-container", "product-form");
  hideElementsInParent("product__info-container", "sealsubs-target-element");
  hideElementsInParent("product__info-container", "main-container");
 
  hideElementsInParent("product-card", "quick-add");

  const priceLoginElements = document.querySelectorAll(".price-login");
  //  List of blocked domains (Hungary, USA, Canada, Indonesia)
  const blockedDomains = [ ".us",".com", ".ca"]; 

  // Check if the current hostname contains any of the blocked domains
  const isBlocked = blockedDomains.some(domain => window.location.hostname.includes(domain));

  //  Only allow redirection if it's NOT a blocked domain
  if (!isBlocked) {
    priceLoginElements.forEach((element) => {
      element.addEventListener("click", () => {
        const accountLink = document.querySelector('a[href="/account/login"]');
        if (accountLink) {
          accountLink.click();
        }
      });
    });
  }
});




function hideElementsInParent(parentClass, elementToHide) {
  const priceHiddenElements = document.querySelectorAll("p.price-hidden");

  priceHiddenElements.forEach((pTag) => {
    const parentDiv = pTag.closest(`div.${parentClass}`);

    if (parentDiv) {
      const elementsToHide = parentDiv.querySelectorAll(`.${elementToHide}`);

      elementsToHide.forEach((element) => {
        element.style.display = "none";
      });
    }
  });
}

// This script updates the quantity input based on the URL parameter.

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

document.addEventListener("DOMContentLoaded", () => {
  const quantityParam = getQueryParam("quantity");
  if (quantityParam) {
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = quantityParam;
      quantityInput.dispatchEvent(new Event("change"));
    }
  }
});
// This script updates the quantity input based on the URL parameter.